// src/themes/desaturado.js
//
// Tema Desaturado — identidad original del producto.
// Lavanda sobrio sobre navy apagado, pensado para turnos diurnos prolongados.
//
// Sistema A (chrome del tema) calibrado en OKLCH dentro de zona de confort:
//   L 55-78, C 0.05-0.15 para colores de lectura sostenida.
//
// Sistema B (taxonomía operativa) se unifica con Vibrante y Tactical — ver
// nota al final del archivo. La taxonomía NO vive en este archivo: vive en
// src/themes/system-b.js y se mergea via apply.js.
//
// Fixes aplicados respecto de la versión anterior:
//   - accentGlow y borderAccent ahora derivan del accent (antes usaban #9588F0)
//   - textFaint → textDim (renombrado para alinear con consumidores del código)
//   - text primario y textDim ahora son hex explícitos (antes white@alpha)

export default {
  id: 'desaturado',
  label: 'Desaturado (Clásico)',
  mapBasemap: 'dark',

  // ========== SISTEMA A — CHROME ==========

  // Identidad — lavanda sobrio, L 74 C 0.09 H 284
  accent:       '#B4A9FF',
  accentSoft:   'rgba(180, 169, 255, 0.22)',
  accentGlow:   'rgba(180, 169, 255, 0.40)',
  accentBright: '#C9BFFF',

  // Fondos — navy apagado, 3 niveles de elevación
  bgDeep:    '#0A1222',
  bgSurface: '#11192B',
  bgCard:    '#060A14',
  bgOverlay: 'rgba(10, 14, 26, 0.92)',

  // Texto — off-white con tinte lavanda sutil, predecible sobre cualquier bg
  text:      '#E6E8F0',
  textMuted: '#8C9BB3',
  textDim:   '#64708B',

  // Bordes
  borderDim:    'rgba(255, 255, 255, 0.08)',
  borderNormal: 'rgba(255, 255, 255, 0.12)',
  borderAccent: 'rgba(180, 169, 255, 0.35)',

  // Trail GPS — cyan neutro, funciona como highlighter sobre el mapa
  trailLine: '#00BCD4',

  // Murphy themed — derivado del lavanda accent. Solo se aplica si el modo
  // Murphy es 'themed'. En 'neutral' (default) lo overridean los grises.
  murphyLight: '#C9BFFF',
  murphyMid:   '#B4A9FF',
  murphyDeep2: '#7768AB',
  murphyDeep1: '#4A3F75',
  murphyInk:   '#15102C',

  // Tokens extendidos — Desaturado usa defaults neutros
  fontFamily:         "'Public Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  labelTransform:     'none',
  labelLetterSpacing: 'normal',
  accentTextShadow:   'none',
  alertTextShadow:    'none',
  accentBoxShadow:    'none',
  alertBoxShadow:     'none',
  routeActiveWidth:   4,
  routePreviewWidth:  2.5,
  clusterMode:        'colorful',

  // ========== Categorías 911 (manual oficial federal CNIE v3.0) ==========
  // Cada categoría con su familia cromática del manual ajustada al rango
  // medio del tema desaturado. Se inyectan al DOM como --kln-cat-<slug>
  // y los consume el chip del sidebar, header del drawer, halo del marker
  // y el chip de "Categoría:" del drawer. Mantener consistente con
  // src/components/map-v2/theming/palettes/desaturado.js (esa la consume
  // el generador de SVGs pre-pintados; cualquier cambio acá debe
  // replicarse allá).
  catSeguridad:         '#5489D6',  // azul (policía/federal)
  catMedico:            '#5BA86E',  // verde sanitario
  catProteccionCivil:   '#E0B22D',  // amarillo dorado puro (separado de asistencia)
  catServiciosPublicos: '#8A6FCC',  // morado institucional
  catAsistencia:        '#D77236',  // naranja-rojizo (separado de PC)
  catOtrosServicios:    '#5F6B7A',  // gris oscuro
  catMalUso:            '#D14B4B',  // rojo (advertencia mal uso)
}

// Nota de migración desde el schema anterior:
//   textFaint → textDim (renombrado)
//   Los tokens del Sistema B (entityBlue, statusOnline, alertSos, kpiSeguridad,
//   etc.) ya NO se declaran en este archivo. apply.js los mergea desde
//   src/themes/system-b.js antes de emitir las CSS vars.
